import React, { useEffect, useRef, useState } from 'react';
import './styles.scss';
import { useDisclosure } from '@mantine/hooks';
import * as Unicons from '@iconscout/react-unicons';
import {
  FiMenu,
  FiX,
  FiSearch,
  FiChevronDown,
  FiChevronRight,
  FiBell
} from 'react-icons/fi';
import Button from '../../../../elements/Button';
import SearchInput from '../../../../elements/SearchInput';
import BrandLogo from '../../../../../assets/icon/logo-beelajar-horizontal_143x40.svg';
import { UserAuth } from '../../../../../types/user';
import { IMG_MYSTERYMAN } from '../../../../c_avatar/Avatar.const';
import DropdownNavigation from './DropdownNavigation';
import ModalLogout from '../../../../fragments/ModalLogout';
import MenuCategory from './MenuCategory';
import { MenuList } from '../../../../../types/menu';
import Menus from '../../../Menus';
import {
  Box,
  Card,
  Checkbox,
  Divider,
  Image,
  Indicator,
  Modal,
  Text
} from '@mantine/core';
import MobileMenuItem from './MobileMenuItem';
import { HttpService, getSharepointCdnFile } from '../../../../../utilities';
import { useMutation, useQuery } from '@tanstack/react-query';
import { showNotification } from '../../../../../utilities/mantineNotification';
import {
  getCategoryList,
  getDataInterestUser,
  getMasterInterest,
  postInterest
} from '../../../../../services/navbar';
import { useHistory } from 'react-router-dom';
import { getNotification } from '../../../../../services/notification';
import ModalInterest from './ModalInterest';
import { ApiService } from '../../../../../constants/ApiService';
import { ThemeSystem } from '../../../../../views/my-learning/dashboard/themeColor';

interface HeaderNavigationProps {
  user: UserAuth;
  menuList: MenuList[];
  theme?: ThemeSystem;
}

const HeaderNavigation: React.FC<HeaderNavigationProps> = ({
  user,
  menuList,
  theme
}) => {
  const [openDropdown, setOpenDropdown] = useState<boolean>(false);
  const [openCategory, setOpenCategory] = useState<boolean>(false);
  const [openMenuMobile, setOpenMenuMobile] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string | null>(null);
  const [needView, setNeedView] = useState<number>(0);
  const [opened, { open, close }] = useDisclosure(false);
  const ref = useRef<HTMLDivElement>(null);

  const history = useHistory();

  const fetchCategory = useMutation({
    mutationFn: () => getCategoryList(),
    onError: (error: any) => {
      showNotification({
        type: 'error',
        message: error
      });
    }
  });

  useEffect(() => {
    fetchCategory.mutate();
  }, []); //

  useEffect(() => {
    if (history.location.pathname === '/search') {
      const searchData = decodeURIComponent(
        history.location.search.split('=')[1]
      );
      setSearchValue(searchData);
    }
  }, [history.location.pathname]); //

  const fetchedNotif = useQuery({
    queryKey: ['getNotification'],
    queryFn: () => getNotification({})
  });

  useEffect(() => {
    const totalNotif = fetchedNotif?.data?.data?.data?.filter(
      (notif) => notif.isView === false
    );
    if (totalNotif?.length > 0) {
      setNeedView(needView + totalNotif.length);
    }
  }, []);

  const getUserData: any = () => {
    const jsonString = localStorage.getItem('persist:root');
    const object = JSON.parse(jsonString);
    return JSON.parse(object.auth).userData;
  };

  useEffect(() => {
    const _userData = getUserData();
    requestGetTodoList(_userData.binusianId);
  }, []);

  const requestGetTodoList = (binusianId) => {
    // binusianId = '1601246934';
    const payload = {
      BinusianId: binusianId
    };

    HttpService.post(ApiService.beelajar.getTodoList, payload)
      .then((resp) => {
        if (resp.data.length > 0) {
          setNeedView(needView + resp.data.length);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        ref.current &&
        openDropdown &&
        !ref.current.contains(event.target as Node)
      ) {
        setOpenDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openDropdown]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        ref.current &&
        openCategory &&
        !ref.current.contains(event.target as Node)
      ) {
        setOpenCategory(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openCategory]);

  useEffect(() => {
    // Update the overflow style of the body element whenever openMenuMobile changes
    document.body.style.overflowY = openMenuMobile ? 'hidden' : 'auto';
  }, [openMenuMobile]); // Depend on openMenuMobile

  const handleLogout = () => {
    open();
  };

  return (
    <>
      <div className="b-header">
        <nav
          className="b-header__desktop"
          style={
            theme
              ? {
                  backgroundColor: theme.colors.backgroundNavigation,
                  borderBottom: `1px solid ${
                    theme.type === 'dark' ? theme.colors.border : '#dee2e6'
                  }`
                }
              : {}
          }
        >
          <div
            className="wrapper-category-menu"
            onMouseEnter={() => setOpenCategory(true)}
            onMouseLeave={() => setOpenCategory(false)}
          >
            <Button
              variant="transparent"
              className={theme?.type === 'dark' ? 'dark' : ''}
            >
              Categories
            </Button>

            {openCategory && (
              <MenuCategory
                ref={ref}
                list={fetchCategory?.data?.data?.data || []}
                classes="wrapper-category-menu__container"
              />
            )}
          </div>
          <div style={{ flex: 1 }}>
            <SearchInput
              leftIcon={<Unicons.UilSearch />}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  history.push(`/search?search=${e.currentTarget.value}`);
                }
              }}
              onChange={(e) => setSearchValue(e.target.value)}
              value={searchValue}
            />
          </div>
          <div style={{ flex: 1 }}></div>
          <a href="/profile/notification" target="_blank">
            <Button
              styles={{
                marginRight: '0px'
              }}
              variant="transparent"
            >
              <Indicator
                color="red"
                inline
                processing
                disabled={needView === 0 ? true : false}
              >
                <FiBell size={24} />
              </Indicator>
            </Button>
          </a>
          <div
            className="wrapper-dropdown-profile"
            onMouseEnter={() => setOpenDropdown(true)}
            onMouseLeave={() => setOpenDropdown(false)}
          >
            <div
              className={`wrapper-dropdown-profile__dropdown ${
                theme?.type || ''
              }`}
            >
              <div className={'wrapper-dropdown-profile__dropdown__content'}>
                <Box component="div" w={25} h={25}>
                  <Image
                    radius={25}
                    src={
                      user?.photoProfile
                        ? getSharepointCdnFile(user?.photoProfile)
                        : user?.azurePhoto
                        ? user?.azurePhoto
                        : IMG_MYSTERYMAN
                    }
                    alt={user?.fullName}
                    fallbackSrc={IMG_MYSTERYMAN}
                    w={25}
                    h={25}
                  />
                </Box>
                <p
                  className="m-0"
                  style={theme ? { color: theme.colors.text } : {}}
                >
                  {user?.fullName}
                </p>
                <FiChevronDown
                  size={24}
                  style={theme ? { color: theme.colors.text } : {}}
                />
              </div>
            </div>

            {openDropdown && (
              <DropdownNavigation
                ref={ref}
                classes={`wrapper-dropdown-profile__dropdown__container ${
                  theme?.type || ''
                }`}
                handleLogout={handleLogout}
              />
            )}
          </div>
        </nav>

        <nav
          className="b-header__mobile"
          style={
            theme
              ? {
                  backgroundColor: theme.colors.backgroundNavigation
                }
              : {}
          }
        >
          <div
            className="b-icon-menu"
            onClick={() => setOpenMenuMobile(!openMenuMobile)}
          >
            {openMenuMobile ? <FiX size={24} /> : <FiMenu size={24} />}
          </div>
          <img
            src={BrandLogo}
            height={40}
            width={143}
            alt="beelajar-horizontal"
          />
          <div className="b-icon-menu">
            <FiSearch size={24} />
          </div>
        </nav>
      </div>

      {openMenuMobile && (
        <div className="wrapper-menu-mobile">
          <Menus menuList={menuList} />

          <Divider mt={8} mb={8} />

          <MobileMenuItem
            title="Categories"
            rightSection={<FiChevronRight size={24} color="grey" />}
          />

          <MobileMenuItem
            leftSection={
              <img
                src={
                  user?.photoProfile
                    ? getSharepointCdnFile(user?.photoProfile)
                    : user?.azurePhoto || IMG_MYSTERYMAN
                }
                alt={user?.fullName}
                height={24}
                width={24}
              />
            }
            title={user?.fullName}
            rightSection={<FiChevronRight size={24} color="grey" />}
          />
        </div>
      )}

      <ModalLogout isOpen={opened} onClose={() => close()} />

      <ModalInterest />
    </>
  );
};

export default HeaderNavigation;
